import { useAudiolab } from "@/components/providers/AudiolabProvider/hooks";
import { hasActiveSession } from "@/lib/auth";
import { saveRedirect } from "@/lib/storage-utils";
import { Flex, Text } from "@radix-ui/themes";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/creators/me")({
  component: RouteComponent,
  head: () => noindexHead("My Profile | Lutely"),
  beforeLoad: async ({ location }) => {
    const isAuthenticated = await hasActiveSession();
    if (!isAuthenticated) {
      saveRedirect(location.href);
      throw redirect({
        to: "/",
        search: { auth: "login" as const },
      });
    }
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  // "me" resolves to the artist the user is acting as (falls back to the
  // default creator inside AudiolabProvider when nothing was selected)
  const { selectedCreator: creator } = useAudiolab();

  useEffect(() => {
    if (creator) {
      navigate({
        to: "/creators/$CREATOR_ID",
        params: { CREATOR_ID: creator.creatorId },
        replace: true,
      });
    }
  }, [creator, navigate]);

  // Show loading state while we figure out which creator to show
  return (
    <Flex className="min-h-screen w-full items-center justify-center">
      <Text>Loading...</Text>
    </Flex>
  );
}
